document.addEventListener("turbo:load", function() {
  $("#js-workship-cv-file-field").on("change", function () {
    filename = this.files[0].name
    $("#js-workship-cv-file-container").html(`<span class="workship-landingpage__label-text" id= "file-uploaded"> ${filename} </span>`);
  });

})
